import { useParams } from 'react-router-dom';

import { offerStore } from 'containers/Offers/Offer/store';
import { CRUDTable } from 'components';

import { useGetCompanies, usePatchRequest, usePostRequest, useUserRole } from 'hooks';

import { OfferItemIdentity, OfferItemIdentityUpdate } from 'codegen';

import { IdentitiesFieldsChange } from './IdentitiesFieldsChange';
import {
  columns,
  handlePatchIdentity,
  handlePostIdentity,
  handleSuccessPatchIdentities,
  handleSuccessPostIdentities,
  initialTableActions,
} from './identitiesHelpers';

export const Identities = () => {
  const identities = offerStore((state) => state.identities);
  const selectedItemId = offerStore((state) => state.selectedItemId);

  const { offerId } = useParams();

  const [{ companies }] = useGetCompanies(true);

  const [postIdentities, { loading }] = usePostRequest<OfferItemIdentity, OfferItemIdentityUpdate>({
    options: {
      onSuccess: handleSuccessPostIdentities(identities),
    },
  });

  const [patchIdentities, { loading: patchLoading }] = usePatchRequest<OfferItemIdentity, OfferItemIdentityUpdate>({
    options: {
      onSuccess: handleSuccessPatchIdentities(identities),
    },
  });

  const { isAdmin } = useUserRole();

  return (
    <CRUDTable
      title='Identities'
      rowKey='id'
      loading={loading || patchLoading}
      columns={columns(companies)}
      addNewBtn={{ visible: isAdmin }}
      dataSource={identities}
      initialTableActions={isAdmin ? initialTableActions : undefined}
      onPostTableData={handlePostIdentity(postIdentities, offerId, selectedItemId)}
      onPatchTableData={handlePatchIdentity(patchIdentities, offerId, selectedItemId)}
    >
      <IdentitiesFieldsChange />
    </CRUDTable>
  );
};
